import React from 'react';

const DetailItem = ({ width, item, detail }) => {
  return (
    <div className='mb-2 flex'>
      <div
        className='has-text-weight-semibold flex justify-between'
        style={{
          width,
          flexShrink: 0,
        }}
      >
        <span>{item}</span>
        <span className='mr-1'>:</span>
      </div>
      <div style={{ wordWrap: 'break-word !important' }}>{detail}</div>
    </div>
  );
};

export default DetailItem;
